/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ModerationDefs from './defs.defs.js'

const $nsid = 'chat.bsky.moderation.getConvo'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  convoId: /*#__PURE__*/ l.string(),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  convo: /*#__PURE__*/ l.ref<ModerationDefs.ConvoView>(
    (() => ModerationDefs.convoView) as any,
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Gets an existing conversation by its ID, for moderation purposes. Does not require the requester to be a member of the conversation. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ['InvalidConvo'])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
